import { compose } from '@bem-react/core';
import {
    Popup as BasePopup,
    withTargetAnchor,
    withThemeNormal,
    withViewDefault
} from '@yandex-lego/components/Popup/desktop';
import { withOutsideClick } from '@yandex-lego/components/withOutsideClick';

import { withDefaultPopupScope } from 'client/common/hooks';

const Popup = compose(
    withTargetAnchor,
    withThemeNormal,
    withViewDefault,
    withOutsideClick
)(BasePopup);

export default withDefaultPopupScope(Popup) as typeof Popup;
